"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.detectContactData.name': 'Rilevamento Dati di Contatto',
    'tools.detectContactData.description': 'Rileva ed estrae automaticamente informazioni di contatto come numeri di telefono, email, indirizzi e nomi dai messaggi degli utenti',
};
